import React from 'react';
import PropTypes from 'prop-types';
import { DownloadIcon, ShoppingCartIcon } from '../../atoms/Icon/Download';
import { ShoppingCartButtonContainer, ButtonContainer, Button, ShoppingCartButton, PB } from './style';
export var PremiumButton = function PremiumButton(props) {
  var handleClick = function handleClick() {
    props.handleClick();
  };

  return React.createElement(PB, {
    active: props.active,
    onClick: handleClick
  }, "COSMOS Premium");
};
PremiumButton.propTypes = {
  handleClick: PropTypes.func,
  active: PropTypes.string
};
export var DownloadButton = function DownloadButton(props) {
  var handleClick = function handleClick(name) {
    props.handleClick();
  };

  return React.createElement(ButtonContainer, null, React.createElement(Button, {
    active: props.active,
    onClick: handleClick
  }, React.createElement(ShoppingCartIcon, {
    counter: props.counter,
    color: props.color,
    width: '35px',
    height: '30px'
  })));
};
export var ShopingCartButton = function ShopingCartButton(props) {
  var handleClick = function handleClick(name) {
    props.handleClick();
  };

  return React.createElement(ShoppingCartButtonContainer, {
    width: '45px',
    height: '45px'
  }, React.createElement(ShoppingCartButton, {
    onClick: handleClick,
    width: '45px',
    height: '45px'
  }, React.createElement(DownloadIcon, {
    color: props.color,
    size: props.size
  })));
};
ShopingCartButton.propTypes = {
  handleClick: PropTypes.func,
  size: PropTypes.string,
  color: PropTypes.string
};
DownloadButton.propTypes = {
  handleClick: PropTypes.func,
  dropdownState: PropTypes.object,
  checkboxState: PropTypes.object,
  toggleShowPlot: PropTypes.func,
  toggleCheckbox: PropTypes.func,
  actions: PropTypes.object,
  color: PropTypes.string,
  tag: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.array,
  header: PropTypes.bool,
  _id: PropTypes.string,
  counter: PropTypes.number,
  tab: PropTypes.bool,
  size: PropTypes.string,
  active: PropTypes.bool
};